/**
 * Installation du portail comme application (PWA, Yros/Kavero#488).
 *
 * Chrome et Edge annoncent qu'une installation est possible par l'événement
 * `beforeinstallprompt`, émis une seule fois et souvent avant que l'espace
 * collaborateur soit monté : l'écoute commence donc au démarrage (`index.js`)
 * et l'invite est gardée ici jusqu'au clic. Safari sur iPhone n'émet rien :
 * l'installation y passe par « Partager → Sur l'écran d'accueil ».
 */
let invite = null;
const abonnes = new Set();

const prevenir = () => abonnes.forEach((abonne) => abonne());

export function ecouterInstallation(cible = window) {
  cible.addEventListener('beforeinstallprompt', (evenement) => {
    // Sans cela, le navigateur affiche sa propre bannière.
    evenement.preventDefault();
    invite = evenement;
    prevenir();
  });
  cible.addEventListener('appinstalled', () => {
    invite = null;
    prevenir();
  });
}

export const inviteInstallation = () => invite;

/** L'invite ne sert qu'une fois : le navigateur en émettra une autre. */
export function consommerInvite() {
  const courante = invite;
  invite = null;
  prevenir();
  return courante;
}

export function abonnerInstallation(abonne) {
  abonnes.add(abonne);
  return () => abonnes.delete(abonne);
}

export function estInstallee(fenetre = window) {
  return Boolean(fenetre.matchMedia?.('(display-mode: standalone)').matches
    || fenetre.navigator.standalone === true);
}

export function estIos(navigateur = window.navigator) {
  // L'iPad récent se présente comme un Mac : seul l'écran tactile le trahit.
  return /iphone|ipad|ipod/i.test(navigateur.userAgent)
    || (navigateur.platform === 'MacIntel' && navigateur.maxTouchPoints > 1);
}
